/* owkar-warranty.js - OWKAR Warranty Page Specific Interactions */

document.addEventListener('DOMContentLoaded', () => {
  initBannerParallax();
});

/* --- Banner Parallax Effect --- */
function initBannerParallax() {
  const banner = document.querySelector('.space-banner-card');
  const bannerImg = document.querySelector('.space-banner-img');
  if (!banner || !bannerImg) return;

  function handleParallax() {
    const rect = banner.getBoundingClientRect();
    const viewHeight = window.innerHeight;
    if (rect.top < viewHeight && rect.bottom > 0) {
      const scrollProgress = (viewHeight - rect.top) / (viewHeight + rect.height);
      const translateY = (scrollProgress - 0.5) * 80;
      bannerImg.style.transform = `translateY(${translateY}px)`;
    }
  }

  window.addEventListener('scroll', handleParallax);
  window.addEventListener('resize', handleParallax);
  handleParallax();
}
